<template>
  <div>
    <div class="md-modal modal-msg md-modal-transition" v-bind:class="{'md-show':c_mdshow_edit}">
      <div class="md-modal-inner">
        <div class="md-top">
          <button class="md-close" @click='closeModal'>Close</button>
        </div>
        <div class="md-content">
          <div class="confirm-tips">
            <slot name="msg"></slot>
          </div>
          <div class="form">
            <el-form ref="form" :model="c_addressDetailObj" label-width="100px">
              <el-form-item label="收货人姓名">
                <el-input v-model="c_addressDetailObj.userName" clearable></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                <el-input v-model="c_addressDetailObj.telNumber" clearable></el-input>
              </el-form-item>
              <el-form-item label="省市区">


                <div class="linkage">
                  <el-select
                    class="region_input"
                    v-model="c_addressDetailObj.provinceName"
                    @change="choseProvince"
                    placeholder="省级地区">
                    <el-option
                      v-for="item in province"
                      :key="item.id"
                      :label="item.value"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select
                    class="region_input"
                    v-model="c_addressDetailObj.cityName"
                    @change="choseCity"
                    placeholder="市级地区">
                    <el-option
                      v-for="item in shi1"
                      :key="item.id"
                      :label="item.value"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select
                    class="region_input"
                    v-model="c_addressDetailObj.countyName"
                    @change="choseBlock"
                    placeholder="区级地区">
                    <el-option
                      v-for="item in qu1"
                      :key="item.id"
                      :label="item.value"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="详细地址">
                <el-input type="textarea" v-model="c_addressDetailObj.detailInfo" clearable></el-input>
              </el-form-item>
              <el-form-item label="设为默认">
                <el-switch v-model="c_default"></el-switch>
              </el-form-item>
              <el-form-item id="submit">
                <el-button type="primary" @click="onSubmit">确定</el-button>
                <el-button @click='closeModal'>取消</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="btn-wrap">
            <slot name="btnGroup"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class='md-overlay' v-if="c_mdshow_edit" @click='closeModal'></div>
  </div>

</template>

<script>
  import axios from "axios"
  import "@/assets/css/index.css"
  import {getCookie,removeHTMLTag,isValidPhone,isValidName} from "../util/util";

  export default {
    props: ["c_mdshow_edit","c_editId","c_addressDetailObj","c_default"],
    data() {
      return {
        mapJson: '../static/json/map.json',
        // mapJson: 'https://uat.liferiverai.cn/jyw-web/static/json/map.json',
        province: '',
        sheng: '',
        shi: '',
        shi1: [],
        qu: '',
        qu1: [],
        city: '',
        block: '',
        // isDefault:this.c_default
      };
    },
    // computed:{
    //   isDefault(){
    //     return this.$emit("c_default")
    //   }
    // },
    created: function () {
      // this.$emit("c_getAddressDetail")
    },
    mounted(){
      this.getCityData()
    },
    methods: {
      init: function(obj){
        this.choseProvince(obj.provinceName)
        this.choseCity(obj.cityName)
      },
      // 加载china地点数据，三级
      getCityData: function () {
        var that = this
        axios.defaults.baseURL = ''
        axios.get(this.mapJson).then(function (response) {
          axios.defaults.baseURL = process.env.API_ROOT
          if (response.status == 200) {
            var data = response.data
            // console.log(data)
            that.province = []
            that.city = []
            that.block = []
            // 省市区数据分类
            for (var item in data) {
              if (item.match(/0000$/)) {//省
                that.province.push({id: item, value: data[item], children: []})
              } else if (item.match(/00$/)) {//市
                that.city.push({id: item, value: data[item], children: []})
              } else {//区
                that.block.push({id: item, value: data[item]})
              }
            }
            // 分类市级
            for (var index in that.province) {
              for (var index1 in that.city) {
                if (that.province[index].id.slice(0, 2) === that.city[index1].id.slice(0, 2)) {
                  that.province[index].children.push(that.city[index1])
                }
              }
            }
            // 分类区级
            for (var item1 in that.city) {
              for (var item2 in that.block) {
                if (that.block[item2].id.slice(0, 4) === that.city[item1].id.slice(0, 4)) {
                  that.city[item1].children.push(that.block[item2])
                }
              }
            }
          }
          else {
            console.log(response.status)
          }
        }).catch(function (error) {
          console.log(typeof+error)
        })
      },
      // 选省
      choseProvince: function (e) {
        console.log(e)
        console.log(this.province);
        for (var index2 in this.province) {
          if (e === this.province[index2].value) {
            this.sheng = this.province[index2].value
            this.c_addressDetailObj.provinceName = this.sheng
            this.c_addressDetailObj.cityName = ""
            this.c_addressDetailObj.countyName = ""

            this.shi1 = this.province[index2].children
            this.shi = this.province[index2].children[0].value
            this.qu1 = this.province[index2].children[0].children
            this.qu = this.province[index2].children[0].children[0].value
            this.E = this.qu1[0].id
          }
        }
        console.log(this.sheng)
      },
      // 选市
      choseCity: function (e) {
        console.log(this.city);
        for (var index3 in this.city) {
          if (e === this.city[index3].value) {
            this.shi = this.city[index3].value
            this.c_addressDetailObj.cityName = this.shi
            this.c_addressDetailObj.countyName = ""
            this.qu1 = this.city[index3].children
            // this.qu = this.city[index3].children[0].value
            this.E = this.qu1[0].id
            console.log(this.shi)
          }
        }
      },
      // 选区
      choseBlock: function (e) {
        this.E = e;
        for (var index3 in this.block) {
          if (e === this.block[index3].value) {
            this.qu = this.block[index3].value
            this.c_addressDetailObj.countyName = this.qu
          }
        }
      },
      closeModal() {
        this.$emit('c_close_edit')
      },
      onSubmit() {
        this.editAddress()
        // this.ruleForm.name = addressList[i].userName
        // this.ruleForm.mobile = addressList[i].telNumber
        // this.sheng = addressList[i].provinceName
        // this.shi = addressList[i].cityName
        // this.qu = addressList[i].countyName
        // this.ruleForm.detailInfo = addressList[i].detailInfo
        // this.ruleForm.default = addressList[i].default
      },

      // 编辑地址
      editAddress() {
        if (!this.c_addressDetailObj.userName) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('请输入收货人姓名'),
            type: 'error'
          });
          return false;
        }
        if (!isValidName(this.c_addressDetailObj.userName)) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('姓名不正确'),
            type: 'error'
          });
          return false;
        }
        if (!this.c_addressDetailObj.telNumber) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('请输入手机号'),
            type: 'error'
          });
          return false;
        }
        if (!isValidPhone(this.c_addressDetailObj.telNumber)) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('手机号不正确'),
            type: 'error'
          });
          return false;
        }
        axios.put("/jys/address/"+this.c_editId, {
          userName:this.c_addressDetailObj.userName,
          telNumber:this.c_addressDetailObj.telNumber,
          provinceName: this.sheng ? this.sheng : this.c_addressDetailObj.provinceName,
          cityName: this.shi ? this.shi : this.c_addressDetailObj.cityName,
          countyName: this.qu ? this.qu : this.c_addressDetailObj.countyName,
          detailInfo:this.c_addressDetailObj.detailInfo,
          isDefault:this.c_default,
        }, {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((respnse) => {
          if(respnse.data.code == 0){
            this.closeModal()
            this.$message({
              type: 'success',
              message: '编辑成功!'
            });
            this.$emit('c_getList_edit')
            // this.c_addressDetailObj.userName = ""
            // this.c_addressDetailObj.mobile = ""
            // this.sheng = ""
            // this.shi = ""
            // this.qu = ""
            // this.c_addressDetailObj.detailInfo = ""
            // this.c_addressDetailObj.default = false
          }
        })
      }
    }
  }
</script>
<style>
  /*.form{*/
  /*width: 100%;*/
  /*heigth:200px;*/
  /*}*/
  .el-switch.is-checked .el-switch__core {
    border-color: #00C5B0;
    background-color: #00C5B0;
  }

  .el-button--default:focus, .el-button--default:hover {
    border-color: #00C5B0;
    color: #00C5B0;
    background-color: #fff;
  }

  .el-button--primary:focus, .el-button--primary:hover {
    background: #00C5B0;
    border-color: #00C5B0;
    color: #ffffff;
  }

  .region_input {
    margin-bottom: 20px;
  }

  #submit {
    text-align: center;
  }

  #submit .el-form-item__content {
    margin-left: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/AddressEditModal.vue